import { render, staticRenderFns } from "./roleAction.vue?vue&type=template&id=e85b297a&"
import script from "./roleAction.vue?vue&type=script&lang=js&"
export * from "./roleAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports